import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VirtualDocument } from '@cots/common/resources/virtual-document';
import { DocumentService } from '@cots/common/services/document.service';
import { UtilityService } from '@cots/common/services/utility.service';
import { Customer } from '@cots/customer/resources/customer';
import { CustomerService } from '@cots/customer/services/customer.service';

@Component({
  selector: 'customer-document-list',
  templateUrl: './customer-document-list.component.html',
  styleUrls: ['./customer-document-list.component.less']
})
export class CustomerDocumentListComponent implements OnInit {
  @Input() customer: Customer;
  @Input() editing = false;

  @Input() loading = false;
  @Output() loadingChange = new EventEmitter<boolean>();
  

  constructor(private documentService: DocumentService, private customerService: CustomerService, private utilityService: UtilityService) { }

  ngOnInit(): void {
  }

  public async uploadFunction(files: File[]): Promise<VirtualDocument[]> {
    this.loadingChange.emit(true);
    const vdocs = await Promise.all(files.map(f => this.documentService.upload(f as any).toPromise()));
    const cdocs = await this.customerService.addCustomerDocuments(this.customer, vdocs).toPromise();
    this.customer.documents = [...this.customer.documents, ...cdocs.map(cd => ({
      ...cd,
      document: vdocs.find(d => d.documentId === cd.documentId)
    }))];
    console.log(this.customer.documents.length);
    this.loadingChange.emit(false);
    return vdocs;
  }

  public get documents(): VirtualDocument[] {
    return this.customer.documents.map(d => d.document);
  }
  
  public async onTagsEdited(data: { document: VirtualDocument, newTags: string[] }) {
    const doc = this.customer.documents.find(d => d.documentId === data.document.documentId);
    doc.document.tags = data.newTags; 
    await this.documentService.setTags(doc.document).toPromise();
  }
  
  
  public async onDocumentDeleted(document: VirtualDocument) {
    const r = await this.utilityService.showConfirmationPromise("Delete document?", `Are you sure you want to delete the document <b>${document.name}</b>?`);
    if (!r) return;
    this.loadingChange.emit(true);
    await this.documentService.delete(document).toPromise();
    this.customer.documents = this.customer.documents.filter(d => d.documentId !== document.documentId);
    this.loadingChange.emit(false);
  }

}
